export const analyticsId = {
  ERROR_VIEW: 'ERROR_VIEW',
  SUCCESS_VIEW: 'SUCCESS_VIEW',
  SUCCESS_EVENT: 'SUCCESS_EVENT',
  ERROR_VIEW_CLICK_BUTTON: 'ERROR_VIEW_CLICK_BUTTON',
  ERROR_VIEW_CLICK_PHONE: 'ERROR_VIEW_CLICK_PHONE',
  SUCCESS_VIEW_CLICK_BUTTON: 'SUCCESS_VIEW_CLICK_BUTTON',
};

export const catalogue = {
  [analyticsId.ERROR_VIEW]: errorDescription => ({
    event_name: 'step_error',
    pageName: '/migration/error/somethingWentWrong',
    sectionFamily: 'banking',
    sectionCategory: 'services',
    sectionName: 'customer',
    interactionType: 'funnel',
    serviceType: 'userSettings',
    processType: 'migration',
    processStep: 'error',
    processDetail: 'somethingWentWrong',
    errorCategory: 'somethingWentWrong',
    nombrePagina: 'proc-migracion/error',
    tipoProceso: 'proc-migracion',
    pasoProceso: 'error',
    tipoPagina: 'generica',
    errorDescription,
  }),
  [analyticsId.SUCCESS_VIEW]: () => ({
    event_name: 'step_success',
    pageName: '/migration/success',
    sectionFamily: 'banking',
    sectionCategory: 'services',
    sectionName: 'customer',
    interactionType: 'funnel',
    serviceType: 'userSettings',
    processType: 'migration',
    processStep: 'success',
    nombrePagina: 'proc-migracion/exito',
    tipoProceso: 'proc-migracion',
    pasoProceso: 'exito',
    tipoPagina: 'generica',
  }),
  [analyticsId.SUCCESS_EVENT]: () => ({
    event_name: 'event_success',
    categoriaEvento: '/migration/step02/videocallIdentification',
    accionEvento: 'success',
    etiquetaEvento: 'backend',
    action: 'success',
    format: 'steps',
    component: 'funnel',
    element: 'videocallIdentification',
  }),
  [analyticsId.ERROR_VIEW_CLICK_BUTTON]: () => ({
    categoriaEvento: 'interaccion en migracion',
    accionEvento: 'error',
    etiquetaEvento: 'ir a posicion global',
    action: 'click',
    format: 'button',
    component: 'lowerNavigation',
    element: 'goToGlobalPosition',
  }),
  [analyticsId.ERROR_VIEW_CLICK_PHONE]: () => ({
    categoriaEvento: 'interaccion en migracion',
    accionEvento: 'error',
    etiquetaEvento: 'call center',
    action: 'click',
    format: 'link',
    component: 'confirmationMessage',
    element: 'callCenter',
  }),
  [analyticsId.SUCCESS_VIEW_CLICK_BUTTON]: () => ({
    categoriaEvento: 'interaccion en migracion',
    accionEvento: 'exito',
    etiquetaEvento: 'entendido',
    action: 'click',
    format: 'button',
    component: 'lowerNavigation',
    element: 'understood',
  }),
};
